import axios from 'axios'
import constants from '../../../constants'
import { Task, TaskLogPayload, TaskPayload } from './types'

export const getTasks = async (customerNumber: string, includeLogs: boolean) => {
  const queryParams = includeLogs ? '?scope=withLogs' : ''
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/tasks${queryParams}`)
  const tasks: Task[] = response.data
  
  return tasks
}

export const createTask = async (customerNumber: string, task: TaskPayload) => {
  const { data } = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/tasks`, task)
  return data
}

export const updateTask = async (customerNumber: string, taskId: number, task: TaskPayload) => {
  const { data } = await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/tasks/${taskId}`, task)
  return data
}

export const deleteTask = async (customerNumber: string, task: Task) => {
  const { data } = await axios.delete(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/tasks/${task.id}`)
  return data
}

export const createTaskLog = async (customerNumber: string, taskLog: TaskLogPayload) => {
  const { data } = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/task-logs`, taskLog)
  return data
}

export const updateTaskLog = async (customerNumber: string, taskLog: TaskLogPayload) => {
  const { data } = await axios.patch(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/task-logs/${taskLog.id}`, taskLog)
  return data
}